import React from 'react'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { IColoredTheme } from '../../styles'
import { StyledDatePickerWrapper } from './styled'

interface IStyledDatePicker extends IColoredTheme {
  open: boolean
  selected: string
  onChange: (value: string) => void
  format?: string
}

export const StyledDatePicker = ({
  open,
  selected,
  onChange,
  format = 'YYYY-MM-DD',
  theme = 'green',
  ...props
}: IStyledDatePicker & any) =>
  open ? (
    <StyledDatePickerWrapper theme={theme}>
      <DatePicker
        {...props}
        inline
        formatWeekDay={(day) => day[0]} // Short format for weekdays (Sunday => S)
        dateFormat={format}
        selected={
          moment(selected, format).isValid()
            ? moment(selected, format).toDate()
            : new Date()
        }
        onChange={(value) => onChange(moment(value).format(format))}
      />
    </StyledDatePickerWrapper>
  ) : null
